module.exports = __webpack_public_path__ + "img/rescueAndBomb.8f55b243.jpg";